<mat-card-content class="mat-card-style-search-result">
  <div class="table-responsive">
    <table mat-table multiTemplateDataRows [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="select">
        <th mat-header-cell class="mat-header-cell-checkbox" *matHeaderCellDef>
          <mat-checkbox 
            (change)="$event ? this.masterToggle(selectionClaimCharge, dataSource) : null; onChangeSelection($event, selectionClaimCharge)"
            [checked]="selectionClaimCharge.hasValue() && isAllSelected(selectionClaimCharge, dataSource)"
            [indeterminate]="selectionClaimCharge.hasValue() && !isAllSelected(selectionClaimCharge, dataSource)" 
            [aria-label]="checkboxLabel(selectionClaimCharge, dataSource)"
            color="primary" [disabled]="chkBoxDisabled">
          </mat-checkbox>
        </th>
        <td mat-cell class="mat-cell-checkbox" *matCellDef="let e">
          <mat-checkbox 
            (click)="$event.stopPropagation()"
            (change)="$event ? this.selectionClaimCharge.toggle(e) : null; onChangeSelection($event, selectionClaimCharge)"
            [checked]="selectionClaimCharge.isSelected(e)" 
            [aria-label]="checkboxLabel(selectionClaimCharge, dataSource, e)" 
            color="primary" [disabled]="chkBoxDisabled">
          </mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="firstSrvctrNo">
        <th mat-header-cell class="border-bottom-double" *matHeaderCellDef mat-sort-header>
          契約番号
        </th>
        <td mat-cell *matCellDef="let e">
          {{ e.firstSrvctrNo }}
        </td>
      </ng-container>

      <ng-container matColumnDef="shiyouBashoJusho">
        <th mat-header-cell class="border-bottom-double jusho-width" *matHeaderCellDef mat-sort-header>
          使用場所住所
        </th>
        <td mat-cell class="jusho-width" *matCellDef="let e">
          {{ e.description }}{{ e.mptAname }}{{ e.townAreaName }}{{ e.ooazaName }}
          {{ e.chomeanameIkaKanjitext }}{{ e.supadrKanjiAname1 }}{{ e.yagouAname }}
        </td>
      </ng-container>

      <ng-container matColumnDef="visitName">
        <th mat-header-cell class="border-bottom-double name-width" *matHeaderCellDef mat-sort-header>
          お客さま名
        </th>
        <td mat-cell class="name-width" *matCellDef="let e">
          {{ e.visitName }}
        </td>
      </ng-container>

      <ng-container matColumnDef="energyClsfyCodeaname">
        <th mat-header-cell class="border-bottom-double" *matHeaderCellDef mat-sort-header>
          エネルギー種別／熱量
        </th>
        <td mat-cell *matCellDef="let e">
          {{ e.energyClsfyCodeaname }}{{ e.pipe }}{{ e.heatAname }}{{ e.unitHeat }}
        </td>
      </ng-container>

      <ng-container matColumnDef="keiyakuJotai">
        <th mat-header-cell class="border-bottom-double" *matHeaderCellDef mat-sort-header>
          契約状態
        </th>
        <td mat-cell *matCellDef="let e">
          {{ e.keiyakuJotai }}
        </td>
      </ng-container>

      <ng-container matColumnDef="firstKenshinscheduledate">
        <th mat-header-cell class="border-bottom-double" *matHeaderCellDef mat-sort-header>
          初回検針日
        </th>
        <td mat-cell *matCellDef="let e">
          {{ e.firstKenshinscheduledate | dateString }}
        </td>
      </ng-container>

      <ng-container matColumnDef="discountextraStartdate">
        <th mat-header-cell class="border-bottom-double" *matHeaderCellDef mat-sort-header>
          割引・割増開始日
        </th>
        <td mat-cell *matCellDef="let e">
          {{ e.discountextraStartdate | dateString }}
        </td>
      </ng-container>

      <ng-container matColumnDef="discountextraUnlockdate">
        <th mat-header-cell class="border-bottom-double" *matHeaderCellDef mat-sort-header>
          割引・割増解除日
        </th>
        <td mat-cell *matCellDef="let e">
          {{ e.discountextraUnlockdate | dateString }}
        </td>
      </ng-container>

      <ng-container matColumnDef="waribikiSyurui">
        <th mat-header-cell class="border-bottom-double" *matHeaderCellDef mat-sort-header>
          割引・割増種類
        </th>
        <td mat-cell *matCellDef="let e">
          {{ discntextraSyuruiAnameDisp }}
        </td>
      </ng-container>

      <ng-container *ngIf="showKingaku" matColumnDef="discountextraMny">
         <th mat-header-cell class="border-bottom-double" *matHeaderCellDef mat-sort-header>
          割引・割増金額
        </th>
        <td mat-cell *matCellDef="let e">
          {{ e.discountextraPointMny }}{{ e.unitMny }}
        </td>
      </ng-container>

      <ng-container *ngIf="!showKingaku" matColumnDef="discountextraRate">
         <th mat-header-cell class="border-bottom-double" *matHeaderCellDef mat-sort-header>
          割引・割増率
        </th>
        <td mat-cell *matCellDef="let e" class="number">
          {{ e.discountextraRate | number }}{{ e.unitRate }}
        </td>
      </ng-container>

      <ng-container matColumnDef="prdGoodsRyaku">
        <th mat-header-cell class="border-bottom-double" *matHeaderCellDef mat-sort-header>
          料金プラン名
        </th>
        <td mat-cell *matCellDef="let e">
          {{ e.prdGoodsRyaku }}
        </td>
      </ng-container>

      <ng-container matColumnDef="suppntSpno">
        <th mat-header-cell class="border-bottom-double" *matHeaderCellDef mat-sort-header>
          供給地点特定番号
        </th>
        <td mat-cell *matCellDef="let e">
          {{ e.suppntSpno }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="setDisplayedColumnsCol; sticky: true"></tr>
      <tr mat-row *matRowDef="let e; columns: setDisplayedColumnsCol"></tr>

    </table>
  </div>
</mat-card-content>

<div *ngIf="dispBotton"  class="tw-flex tw-flex-row tw-flex-wrap" fxLayoutAlign="end center">
  <mat-card-actions class="btn_area_right">
    <button type="button" mat-raised-button color="primary" class="btn"
      (click)="triggerFileInput()" [disabled]="disabledBotton || chkBoxDisabled">
      CSV取込
    </button>
    <input type="file" #fileInput style="display: none" (change)="onClickCsvCapture($event)" accept=".csv"/>
  </mat-card-actions>
  <mat-card-actions class="btn_area_right">
    <button type="button" mat-raised-button color="primary" class="btn"
      (click)="onClickAdd()" [disabled]="disabledBotton || chkBoxDisabled">
      追加
    </button>
  </mat-card-actions>
  <mat-card-actions class="btn_area_right">
    <button type="button" mat-raised-button color="primary" class="btn"
      (click)="onClickEdit(selectionClaimCharge)" [disabled]=isEditDisabled>
      編集
    </button>
  </mat-card-actions>
  <mat-card-actions *ngIf="dispDelBotton" class="btn_area_right">
    <button type="button" mat-raised-button color="primary" class="btn"
      (click)="onClickDel(selectionClaimCharge)" [disabled]=isEditDisabled>
      削除
    </button>
  </mat-card-actions>
</div>